<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">

                <v-card flat>
                    <v-card-text>

                        <div class="form-box-title">{{ $t("Параметры") }}</div>

                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Действие") }}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="9">
                                <v-select
                                    v-model="changeType"
                                    :items="changeTypes"
                                    :item-text="item => $t(item.name)"
                                    item-value="id"
                                    hide-details
                                    required
                                    outlined
                                    dense
                                    append-icon="fas fa-chevron-down"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                >
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row v-if="isTerminating" no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Отменен_с") }}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="9">
                                <v-menu 
                                    v-model="terminationDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="terminationDate | formattedDate"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                            clearable
                                            @click:clear="terminationDate = null"
                                            class="datepick-input"
                                            required
                                            hide-details
                                        >
                                        </v-text-field>
                                    </template>

                                    <v-date-picker
                                        v-model="terminationDate"
                                        @input="terminationDateMenu = false"
                                        color="teal"
                                        :first-day-of-week="1"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-row v-if="isTerminating" no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Причина") }}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="9">
                                <v-textarea
                                    v-model="terminationReason"
                                    class="oneRowStartTextarea"
                                    rows="3"
                                    auto-grow
                                    row-height="16"
                                    no-resize
                                    hide-details
                                    outlined
                                    dense
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
                
                <v-card flat>
                    <v-card-text
                        v-if="documentsLoading"
                        style="min-height: 409px;"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            {{ $t("Загрузка...") }}
                        </v-col>

                        <v-col cols="12">
                            <v-progress-linear
                                color="#a94442"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>

                    </v-card-text>
                    <v-card-text v-else>

                        <div class="form-box-title title-with-right-part">
                            <span>
                                {{ $t("Документ-основание") }}
                            </span>
                            <div class="twrp-content">
                                <v-text-field
                                    :value="documentSearch"
                                    @input="updateDocumentSearch($event)"
                                    :placeholder="$t('Поиск')"
                                    hide-details
                                    dense
                                    clearable
                                    @click:clear="documentSearch = null"
                                    class="twrp-search"
                                    append-icon="fas fa-search"
                                >
                                </v-text-field>
                            </div>
                        </div>

                        
                        <v-list
                            v-if="documents.length > 0"
                            class="modal-select-list"
                            dense
                            outlined
                        >
                            <v-list-item-group
                                v-model="document"
                                color="cyan darken-1"
                            >
                                    <v-list-item
                                        v-for="item in documents"
                                        :key="item.id"
                                        :value="item"
                                        :disabled="item.id == currentDocumentId"
                                    >
                                        <!-- Иконка документа--> 
                                        <v-list-item-avatar>
                                            <v-icon>
                                                fas fa-file-alt
                                            </v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content v-tooltip.top-center="item.theme">

                                            <v-list-item-title>
                                                {{ $t(npaTypeName(item)) }} № {{ item.regnumber }} {{ $t("от_время") }} {{ $moment(item.regdate).format("DD.MM.YYYY") }}{{ item.id == currentDocumentId ? ` (${$t('Текущий_документ')})` : '' }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ item.theme }}
                                            </v-list-item-subtitle>

                                        </v-list-item-content>

                                        <v-list-item-icon
                                            v-if="item.id != currentDocumentId"
                                        >
                                            <div @click.stop="onOpenDocumentInNewTab(item)">
                                                <v-icon
                                                    small
                                                    v-tooltip.left-center="$t('Открыть_документ_в_новой_вкладке')"
                                                >
                                                    fas fa-external-link-square-alt
                                                </v-icon>
                                            </div>
                                        </v-list-item-icon>

                                    </v-list-item>

                            </v-list-item-group>
                            <v-divider></v-divider>
                            <v-pagination
                                v-model="documentsPage"
                                :length="Math.ceil(documentsTotal/documentsPerPage)"
                                :total-visible="9"
                                class="cust-pagination"
                                color="teal"
                            ></v-pagination>
                        </v-list>
                        <v-row v-else no-gutters>
                            <v-col cols="12" sm="12" md="12">
                                <div class="modal-list-placeholder">
                                    {{ $t("К_сожалению,_по_Вашему_запросу_ничего_не_найдено") }}
                                </div>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isValid"
                >
                    {{ $t("Изменить") }}
                </v-btn>

                <v-btn 
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';

export default {
    name: "ChangeStatusNpaDlg",
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    data() {
        return {
            title: "Изменить_статус_НПА",
            visible: false,
            resolve: null,
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },

            changeTypes: [
                { id: 0, name: 'Внесение_изменений' },
                { id: 1, name: 'Утратил_силу' }
            ],
            changeType: 0,

            documentsLoading: false,
            documentsPage: 1,
            documentsPerPage: 6,
            documentSearch: null,
            documents: [],
            documentsTotal: 0,

            document: null,

            terminationDateMenu: false,
            terminationDate: null,
            terminationReason: null
        }
    },
    computed: {
        ...mapGetters('global/actionsource', { currentDocumentId: 'getDataSourceDocumentId', isCommon: 'isDataSourceCommon' }),
        isTerminating() {
            return this.changeType === 1;
        },
        isValid() {
            if (this.changeType === 0) {
                return this.document != null;
            }

            if (this.changeType === 1) {
                return this.terminationDate != null && (this.document != null || this.sanitazedTerminationReason);
            }

            return false;
        },
        sanitazedTerminationReason() {
            return String(this.terminationReason)?.trim() ?? '';
        }
    },
    methods: {
        async open(options = {}) {
            this.reset();

            this.visible = true;
            this.options = Object.assign(this.options, options);

            this.fetchDocuments();

            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        },
        reset() {
            this.changeType = 0;
            this.documentsPage = 1;
            this.documentSearch = null;
            this.document = null;
            this.terminationDateMenu = false;
            this.terminationDate = null;
            this.terminationReason = null;
        },
        ok() {
            this.visible = false;
            this.resolve({ type: this.changeType, date: this.terminationDate ? `/Date(${Date.parse(this.terminationDate)})/` : null, documentId: this.document?.id ?? '00000000-0000-0000-0000-000000000000', reason: this.sanitazedTerminationReason });
        },
        cancel() {
            this.visible = false;
            this.resolve({ isCancelled: true, message: "Действие_отменено" });
        },
        npaTypeName(item){
            switch(item.npatype){
                case 0:
                    return 'Решение';
                case 1:
                    return 'Постановление';
                case 2:
                    return 'Распоряжение';
                default:
                    return 'НПА';
            }
            
        },
        async fetchDocuments() {
            this.documentsLoading = true;

            let filter = 
            {
                SearchStr: this.documentSearch,
                RegState: 1,
                OrderBy: 3,
                OrderDir: true,
                Limit: this.documentsPerPage,
                Offset: (this.documentsPage - 1) * this.documentsPerPage
            };

            if (this.changeType == 1)
                filter.NPAType = 1;

            let response = await httpAPI({
                url: `/api/npa/selectlist?filter=${JSON.stringify(filter)}`,
                method: 'GET',
                headers: { 'isCommon': this.isCommon }
            });

            this.documents = response.data.Payload.data ?? [];
            this.documentsTotal = response.data.Payload.total ?? 0;

            this.documentsLoading = false;
        },
        onOpenDocumentInNewTab(document) {

            let routeData = this.$router.resolve({
                name: `NPADocument${document.npatype}`,
                params: { id: document.id },
                query: { common: this.isCommon }
            });

            // временно удаляем идентификатор сессии, для того, что-бы новая вкладка не скопировала его в свое хранилище
            var sessionId = sessionStorage.getItem('SessionId');
            sessionStorage.removeItem('SessionId');

            window.open(routeData.href, '_blank');
            
            // устанавливаем идентификатор сессии
            sessionStorage.setItem('SessionId', sessionId);
        },
        updateDocumentSearch: _.debounce(function (value) {
            this.documentSearch = value;
        }, 250)
    },
    watch: {
        documentsPage() {
            if (this.visible)
                this.fetchDocuments();
        },
        documentSearch() {
            if (this.visible)
                this.fetchDocuments();
        },
        changeType(){
            if (this.visible)
                this.fetchDocuments();
        }
    }
}
</script>